import { render, staticRenderFns } from "./partner-form.vue?vue&type=template&id=74a69808&"
import script from "./partner-form.vue?vue&type=script&lang=js&"
export * from "./partner-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports